import { useApiClient } from "../../../hooks/useApiClient";
import { type ISelectObject } from "../../../types/select";
import useSWRImmutable from "swr/immutable";
import { type ICommercialLegalAffairsBureauResponse } from "../types";

interface IUseCommercialLegalAffairsBureauReturnType {
  legalAffairsBureauOptions: ISelectObject[];
  isLoading: boolean;
  isError: boolean;
}

/**
 * 商業登記 法務局（legal-affairs-bureau）を取得するカスタムフック
 */
export const useCommercialLegalAffairsBureau =
  (): IUseCommercialLegalAffairsBureauReturnType => {
    const { apiClient } = useApiClient();

    const fetcher = async (
      url: string
    ): Promise<ICommercialLegalAffairsBureauResponse> => {
      const { data } =
        await apiClient.get<ICommercialLegalAffairsBureauResponse>(url);
      return data;
    };

    const toSelectObjectList = (
      data: ICommercialLegalAffairsBureauResponse | undefined
    ): ISelectObject[] => {
      if (data === undefined) return [];

      return data.list.map((item) => ({
        value: item.id.toString(),
        label: item.name,
      }));
    };

    const { data, error, isLoading } = useSWRImmutable<
      ICommercialLegalAffairsBureauResponse,
      Error
    >("option/commercial/legal-affairs-bureau", fetcher);

    return {
      legalAffairsBureauOptions: toSelectObjectList(data),
      isLoading,
      isError: Boolean(error),
    };
  };
